#scolab-switcher-app {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: -80px;
  align-content: stretch;
  justify-content: center;
  z-index: 999999999;
  background-color: #303438;
  border-radius: 8px 8px 0 0;
  display: inline-flex;
  padding: 8px 16px 8px 8px;
  align-items: center;
  gap: 16px;
  animation: slideApp 0.3s ease-out forwards;
}

@keyframes slideApp {
    100% { bottom: 0; }
}

[data-group="scolab-switcher"] {
  font-family: "Open Sans", arial, sans-serif;
}

[data-group="scolab-switcher"] .scolab-switcher-button, .scolab-switcher-select {
  display: block;
  padding: 6px 8px;
  border-radius: 4px;
  border: 0;
  background: #303438;
  color: #FFFFFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  text-align: left;
  cursor: pointer;
}

[data-group="scolab-switcher"] .scolab-switcher-select {
  display: block;
  padding: 0;
  border: 0;
  background: #303438;
  color: #FFFFFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.75px;
  cursor: pointer;
}

[data-group="scolab-switcher"] .scolab-switcher-button-primary {
  background-color: #0068B8;
}
